import { Link } from "react-router-dom";
import { PageIntro } from "../components/PageIntro";
import { Reveal } from "../components/Motion";
import { ArrowRight, Check } from "lucide-react";
import { IMAGES, STATS, INVESTOR_POINTS } from "../data";

export default function Investors() {
  return (
    <div data-testid="investors-page">
      <PageIntro
        label="Investor Information"
        title="Disciplined capital for the minerals of the energy transition."
        subtitle="A London base, sovereign relationships and data-driven evaluation — deployed into critical-resource projects across four continents."
      />

      {/* Stats */}
      <section className="bg-mm-navy">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-2 lg:grid-cols-4 divide-x divide-white/10">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08} className="py-14 px-6 first:pl-0">
              <p className="font-display font-extrabold text-5xl md:text-6xl text-white">{s.value}</p>
              <p className="mt-3 font-mono text-xs tracking-[0.16em] uppercase text-mm-accent">{s.label}</p>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Thesis */}
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-start">
          <Reveal>
            <p className="overline mb-5">The investment thesis</p>
            <h2 className="font-display font-bold text-3xl md:text-4xl leading-tight tracking-tight text-mm-ink">
              Why Mars Mining Limited
            </h2>
            <p className="mt-6 text-lg text-mm-muted leading-relaxed">
              Critical minerals underpin the technologies of the coming decades. We give partners disciplined, well-governed exposure to that opportunity.
            </p>
            <div className="mt-8 aspect-[4/3] overflow-hidden rounded-lg shadow-card">
              <img src={IMAGES.drillRig} alt="Drilling operation" className="w-full h-full object-cover" />
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="space-y-4">
              {INVESTOR_POINTS.map((p) => (
                <div key={p.k} className="bg-white border border-mm-line rounded-lg p-6 shadow-card">
                  <div className="flex items-start gap-4">
                    <div className="h-8 w-8 rounded-md bg-mm-light flex items-center justify-center shrink-0 mt-0.5">
                      <Check size={16} className="text-mm-accent" />
                    </div>
                    <div>
                      <h3 className="font-display font-bold text-lg text-mm-ink">{p.k}</h3>
                      <p className="text-mm-muted leading-relaxed mt-2">{p.v}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-mm-light border-t border-mm-line">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 flex flex-col md:flex-row items-center justify-between gap-8">
          <h2 className="font-display font-bold text-2xl md:text-3xl tracking-tight text-mm-ink max-w-xl">
            Request the investor briefing and current portfolio overview.
          </h2>
          <Link to="/contact" data-testid="investors-cta" className="inline-flex items-center gap-2 px-8 py-4 bg-mm-blue text-white font-semibold rounded-md hover:bg-mm-navy transition-colors shrink-0">
            Contact our team <ArrowRight size={18} />
          </Link>
        </div>
      </section>
    </div>
  );
}
